module.exports = __webpack_public_path__ + "stylesheets/main-page_07c6727aa9339beb1efa072b271f7918.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/main-page.less
// module id = dJ+1
// module chunks = 153